
export const TITLE = "title";
export const VALUE = "value";
export const SUBTITLE = "subtitle";
export const TYPE = "type";
export const ON_TRACK = "on_track";
export const DELAYED = "delayed";
export const CRITICAL = "critical";
export const MAJOR = "major";
export const MINOR = "minor";
export const REWORK = "rework";
export const MAJOR_FAILURE = "major_failure";
export const PROJECT_PLANS = "project_plans";
export const REVISIONS = "revisions";
export const PROJECT_CLOSURE = "project_closure";
export const PROJECT_MANAGERS = "project_managers";
export const SITE_MANAGERS = "site_managers";
export const SAFETY_OFFICERS = "safety_officers";
export const QC_OFFICERS = "qc_officers";
export const NAME = "name";
export const PROGRESS = "progress";
export const STATUS = "status";
export const CATEGORY = "category";
export const NOTE = "note";
export const SAFETY = "safety";
export const QUALITY = "quality";
export const EVENTS = "events";
export const VARIANCE = "variance";
export const LAST_UPDATE = "last_update";
export const TASKS_COMPLETE = "tasks_complete";
export const SAFETY_AUDIT = "safety_audit";
export const QUALITY_AUDIT = "quality_audit";
export const TOTAL_PHOTOS = "total_photos";
export const PENDING_APPROVAL = "pending_approval";
export const APPROVED = "approved";
export const REJECTED = "rejected";
export const PROJECT_LIST = "project_list";

export const bgMap: any = {
  active: "bg-white border-gray-200",
  risk: "bg-red-100 border border-red-200",
  approval: "bg-yellow-50 border border-yellow-100",
  completion: "bg-green-50 border border-green-200",
  overall: "bg-green-50 border border-green-200",
  total: "bg-white border-gray-200",
  delayed: "bg-red-100 border border-red-200",
  blocked: "bg-red-100 border border-red-200",
  quality: "bg-red-100 border border-red-200"
};

export const statusStyles: any = {
  on_track: {
    row: "bg-green-100",
    badge: "bg-green-600 text-white",
  },
  delayed: {
    row: "bg-yellow-50",
    badge: "bg-yellow-500 text-white",
  },
  critical: {
    row: "bg-red-50",
    badge: "bg-red-600 text-white",
  },
};
